import { render } from "./OperationsSafaris.vue?vue&type=template&id=0ca9e55b"
import script from "./OperationsSafaris.vue?vue&type=script&lang=js"
export * from "./OperationsSafaris.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__